import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";
import { useUserRole } from "../hooks/useUserRole";
import { NotificationCenter } from "./NotificationCenter";
import "../styles/Navigation.css";

export function Navigation() {
  const { user, role, isAdmin, isClub } = useUserRole();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const auth = getAuth();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate("/login");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  if (!user) {
    return null;
  }

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo/Brand */}
        <div className="navbar-brand">
          <Link to="/wallet" onClick={closeMenu}>
            💳 GaveKort
          </Link>
        </div>

        {/* Notification Center */}
        <div className="navbar-notifications">
          <NotificationCenter />
        </div>
        <button className="navbar-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          <span className="hamburger"></span>
          <span className="hamburger"></span>
          <span className="hamburger"></span>
        </button>

        {/* Navigation Menu */}
        <div className={`navbar-menu ${menuOpen ? "active" : ""}`}>
          <ul className="navbar-nav">
            {/* Common to all roles */}
            <li className="nav-item">
              <Link to="/wallet" className="nav-link" onClick={closeMenu}>
                🏠 Wallet
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/profile" className="nav-link" onClick={closeMenu}>
                👤 Profile
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/resources" className="nav-link" onClick={closeMenu}>
                📦 Resources
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/analytics" className="nav-link" onClick={closeMenu}>
                📊 Analytics
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/settings" className="nav-link" onClick={closeMenu}>
                ⚙️ Account Settings
              </Link>
            </li>

            <li className="nav-item">
              <Link to="/push-settings" className="nav-link" onClick={closeMenu}>
                🔔 Push Settings
              </Link>
            </li>
            {isAdmin() && (
              <li className="nav-item dropdown">
                <a href="#admin" className="nav-link dropdown-toggle" onClick={(e) => e.preventDefault()}>
                  ⚙️ Management
                </a>
                <ul className="dropdown-menu">
                  <li>
                    <Link to="/admin/users" onClick={closeMenu}>
                      Users
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/giftcards" onClick={closeMenu}>
                      Giftcards
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/qr-scanner" onClick={closeMenu}>
                      QR Scanner
                    </Link>
                  </li>
                  <li>
                    <Link to="/admin/analytics" onClick={closeMenu}>
                      Analytics
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Club/System Admin only */}
            {isClub() && (
              <>
                <li className="nav-item">
                  <Link to="/club/accounting" className="nav-link" onClick={closeMenu}>
                    💰 Accounting
                  </Link>
                </li>
                <li className="nav-item dropdown">
                  <a href="#system" className="nav-link dropdown-toggle" onClick={(e) => e.preventDefault()}>
                    🖥️ System
                  </a>
                  <ul className="dropdown-menu">
                    <li>
                      <Link to="/system/clubs" onClick={closeMenu}>
                        Clubs
                      </Link>
                    </li>
                    <li>
                      <Link to="/system/staff" onClick={closeMenu}>
                        Staff
                      </Link>
                    </li>
                    <li>
                      <Link to="/system/reports" onClick={closeMenu}>
                        Reports
                      </Link>
                    </li>
                    <li>
                      <Link to="/system/audit" onClick={closeMenu}>
                        Audit Log
                      </Link>
                    </li>
                  </ul>
                </li>
              </>
            )}
          </ul>

          {/* User Section */}
          <div className="navbar-user">
            <div className="user-info">
              <div className="user-name">{user.displayName || user.email}</div>
              <div className="user-role">
                {role === "END_USER" && "Member"}
                {role === "ADMIN" && "Manager"}
                {role === "STAFF" && "Staff"}
                {role === "CLUB" && "Administrator"}
              </div>
            </div>
            <button className="logout-btn" onClick={handleLogout}>
              🚪 Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
}
